
@switch (mode) {
  <!-- CASE UPLOAD -->
  @case (FileUploaderMode.UPLOAD) {
    <div class="form-uploader-block flex flex-nowrap justify-center items-center" [ngClass]="{'disabled':currentFiles && currentFiles.length > 0}" #upBlock (click)="openFileUploaderInput()" (drop)="droppedFile($event)" (dragover)="preventDragOver($event)" (dragenter)="setHover(true)" (dragover)="setHover(true)" (dragstart)="setHover(true)" (dragend)="setHover(false)"
      (dragleave)="setHover(false)" (drop)="setHover(false)">
      @if (!archiving) {
        <mat-icon class="form-uploader-upload-icon">upload</mat-icon>
        @if (!currentFiles || currentFiles.length < 1) {
          <div class="flex flex-col justify-center align-middle">
            <p class="d-block"> {{ multiple ? ("ED.CLICK_HERE_TO_DROP_FILES" | translate) : ("ED.CLICK_HERE_TO_DROP_FILE" | translate) }} </p>
            @if (multiple && isMultipleANumber) {
              <p class="sm-text d-block"> {{ "ED.MAX" | translate }}: {{ multiple }} {{ "ED.FILES_MIN" | translate }} </p>
            }
            <p class="sm-text d-block">({{ "ED.ALLOWED_FORMATS" | translate }} : {{ hasFormatWildcard ? ("ED.ALL" | translate) : fileFormats().join(", ") }}) </p>
          </div>
        }
        @if (currentFiles && currentFiles.length > 0) {
          <div class="flex flex-col max-w-[35rem] max-h-[10rem] overflow-y-auto overflow-x-hidden text-ellipsis">
            @for (currentFile of currentFiles; track currentFile) {
              <p class="w-fit flex gap-2 whitespace-nowrap content-center items-center">
                <strong>({{ getSize(currentFile.size) }})</strong>
                <span> - {{ currentFile.name }}</span>
              </p>
            }
            @if (!readOnly  && !clearAndOpenModal()) {
              <span class="form-uploader-clear flex" (click)="clearUploader($event)"><mat-icon>close</mat-icon></span>
            }
          </div>
        }
      }
      @if (archiving) {
        <div class="flex flex-col gap-2 items-center justify-center">
          <strong>{{ 'ARCHIVING' | translate }}</strong>
          <mat-spinner [diameter]="40" color="accent" />
          <p class="italic text-sm">{{ 'ARCHIVING_IN_PROGRESS' | translate }}</p>
          @if (!readOnly  && !clearAndOpenModal()) {
            <span class="form-uploader-clear flex" (click)="clearUploader($event)"><mat-icon>close</mat-icon></span>
          }
        </div>
      }
    </div>
    <input name="file" [disabled]="readOnly" [id]="this.uploaderId" type="file" [accept]="acceptedFormats" class="hidden" [formControl]="fileControl" [multiple]="multiple ? 'multiple' : false" />
  }
  <!-- CASE DOWNLOAD  -->
  @case (FileUploaderMode.DOWNLOADS) {
    <div class="form-uploader-block flex flex-nowrap justify-center gap-4 items-center" #downBlock (click)="download()">
      @if (thumbnail_img$ | async) {
        <img class="max-w-40 max-h-40 justify-start" [src]="thumbnail_img$ | async" />
      }
      @if (currentUploadeds) {
        <div class="flex flex-col max-w-[35rem] max-h-[10rem] overflow-y-auto overflow-x-hidden text-ellipsis">
          @for (currentUploaded of currentUploadeds; track currentUploaded) {
            <p class="w-fit flex gap-2 whitespace-nowrap content-center items-center">
              <strong>({{ getSize(currentUploaded.file_details.size) }})</strong>
              <span> - {{ currentUploaded.file_details.originalname }}</span>
            </p>
          }
        </div>
      }
      @if (!none_exists) {
        <mat-icon class="form-uploader-upload-icon">download</mat-icon>
      }
      @if (!readOnly && !clearAndOpenModal()) {
        <span class="form-uploader-clear flex" (click)="clearUploader($event)"><mat-icon>close</mat-icon></span>
      }
    </div>
    <ng-template #noneExists>
      <div class="form-uploader-block flex gap-2 flex-nowrap justify-center items-center" (click)="openFolder()">
        @if (currentUploadeds) {
          <div class="flex flex-col max-w-[35rem] max-h-[10rem] overflow-y-auto overflow-x-hidden text-ellipsis">
            @for (currentUploaded of currentUploadeds; track currentUploaded) {
              <p class="w-fit flex gap-2 whitespace-nowrap content-center items-center">
                <strong>({{ getSize(currentUploaded.file_details.size) }})</strong>
                <span> - {{ currentUploaded.file_details.originalname }}</span>
              </p>
            }
          </div>
        }
        @if (!isClient) {
          <mat-icon class="form-uploader-upload-icon">folder</mat-icon>
        }
      </div>
    </ng-template>
  }
}
@if (!readOnly && clearAndOpenModal()) {
  <button mat-flat-button class="bg-tw-primary text-tw-lightgrey flex w-full mt-2" (click)="clearAndUpload($event)">
    <div class="flex gap-2 items-center justify-center">
      <mat-icon>cloud_upload</mat-icon>
      <span>{{'FORM.REUPLOAD_FILE' | translate}}</span>
    </div>
  </button>
}
<!--  -->